<!--课程详情-->
<template>
  <a-card style="border-left: none">
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="课时名称">
          <a-input :maxLength="30" allowClear v-model="searchForm.childCourseName" placeholder="请输入课时名称" />
        </a-form-model-item>
        <a-form-model-item label="课时状态">
          <a-select class="serach-item" allowClear v-model="searchForm.statuses" placeholder="请选择课时状态">
            <a-select-option value="0">未开始</a-select-option>
            <a-select-option value="1">进行中</a-select-option>
            <a-select-option value="2">已完成</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button">查询</a-button>
          <a-button @click="searchReset" style="margin-left: 10px">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="reconciliation" @click="batchSettlement()" type="primary">批量结算 </a-button>
          <a-button icon="history" @click="resetComputed()" style="margin-left: 10px" type="primary">重新算分 </a-button>
          <a-button @click="openSnapshot" style="margin-left: 10px" type="primary">清空快照 </a-button>
          <a-button :loading="exportCourseDataLoading" @click="exportData" style="margin-left: 10px" type="primary">导出数据 </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        row-key="id"
        :row-selection="tableSelection"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="progress" slot-scope="text" class="statusName">
          <span v-if="text.progress === 0">
            <div class="yuan active0"></div>
            未开始 <a-icon type="clock-circle" theme="filled" style="margin-left: 5px; color: #c0c0c0" />
          </span>
          <span v-else-if="text.progress === 100">
            <div class="yuan active2"></div>
            已完成 <a-icon type="check-circle" theme="filled" style="margin-left: 5px; color: #52c41a" />
          </span>
          <span v-else>
            <div class="yuan active1"></div>
            进行中 {{ text.progress }}%
          </span>
        </div>
        <div slot="completionRate" slot-scope="text, record">
          {{ text.completionRate > 0 ? text.completionRate + '%' : '--' }}
        </div>
        <div slot="ruleType" slot-scope="text, record">
          {{ ruleType[text.ruleType] }}
        </div>
        <div slot="enabled" slot-scope="text, record">
          {{ text.enabled ? '启用' : '禁用' }}
        </div>
        <div slot="action" slot-scope="text">
          <a @click="snapshotList(text, 1)" style="margin-right: 10px">
            <a-icon type="alert" />
            课时快照
          </a>
          <!-- <a @click="settlement(text)" style="margin-right: 10px">
                        <a-icon type="tags"/>
          课时结算</a>-->
        </div>
      </a-table>
    </div>

    <!--课时快照-->
    <a-modal title="课时快照" :centered="true" v-model="snapshotRelevant.visible" width="85%" @ok="modleOk" @cancel="closeModal">
      <a-card>
        <a-spin :spinning="spinning">
          <!-- <a-button type="primary" @click="allSnapshotReset">全部重置</a-button> -->
          <a-button icon="plus" type="primary" @click="addContent()">添加内容</a-button>
          <a-table
            style="min-width: 800px; margin-top: 15px"
            :scroll="{ y: 350 }"
            rowKey="contentId"
            :columns="snapshotColumns"
            ref="mySnapshotTable"
            :pagination="snapshotTable.tablePagination"
            :loading="snapshotTable.tableLoading"
            :locale="snapshotTable.locale"
            :dataSource="snapshotTable.tableDataSource"
          >
            <div slot="contentType" slot-scope="text">
              <span v-if="text === 1" style="color: #2f4056">测评游戏</span>
              <span v-if="text === 2" style="color: #ff5722">训练游戏</span>
              <span v-if="text === 3" style="color: #009688">题目壳</span>
              <span v-if="text === 4" style="color: #4982ff">课程视频</span>
              <span v-if="text === 5" style="color: #4982ff">亲子游戏</span>
            </div>

            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.abilitys" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="scientificName" slot-scope="text, record">
              <div class="self_td" v-for="item in record.abilitys" :key="item.id">
                {{ item.scientificName }}
              </div>
            </div>
            <div slot="estimatedTime" slot-scope="text">
              <div v-if="text.contentType == 3 || text.contentType == 5">
                <span v-if="text.contentFinishType == 2">{{ EstimatedTime(text.estimatedTime) }}</span>
                <spn v-else>不限时</spn>
              </div>
              <div v-else>{{ EstimatedTime(text.estimatedTime) }}</div>
            </div>
            <div slot="action" slot-scope="text">
              <a @click="snapshotReset(text)" href="javaScript:;">替换内容</a>
              <a style="color: #f00; margin-left: 15px" @click="deleteContent(text)">
                <a-icon type="delete" />
                删除
              </a>
            </div>
          </a-table>
        </a-spin>
      </a-card>
    </a-modal>

    <a-modal
      :centered="true"
      :destroyOnClose="true"
      @ok="replace"
      :confirmLoading="confirmLoading"
      @cancel="courseChildsearchReset('cancel')"
      v-model="snapshotResetRelevant.visible"
      title="添加内容"
      ref="mychild"
      width="1200px"
    >
      <div class="search">
        <a-form-model layout="inline" :model="courseChildForm">
          <a-form-model-item label="游戏名称">
            <a-input allowClear placeholder="请输入游戏名称" :maxLength="20" v-model="courseChildForm.Name" />
          </a-form-model-item>
          <a-form-model-item label="版本名称">
            <a-input allowClear placeholder="请输入版本名称" :maxLength="20" v-model="courseChildForm.versionName" />
          </a-form-model-item>
          <a-form-model-item label="能力维度">
            <a-cascader v-model="selectId" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
          </a-form-model-item>
          <a-form-model-item label="适用年龄">
            <a-input-group compact>
              <a-input-number style="width: 80px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="courseChildForm.minAge" />
              <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
              <a-input-number
                style="width: 80px; text-align: center; border-left: none"
                placeholder="最大年龄"
                :precision="0"
                :min="courseChildForm.minAge"
                :max="150"
                type="number"
                v-model="courseChildForm.maxAge"
              />
            </a-input-group>
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getCourseChildTableData(1)" type="primary" html-type="button"> 查询 </a-button>
            <a-button @click="courseChildsearchReset" style="margin-left: 10px"> 重置 </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div style="overflow: auto">
        <a-table
          :columns="courseChildColumns"
          :row-selection="rowSelection"
          rowKey="id"
          :scroll="{ y: 350 }"
          :loading="courseChildTable.tableLoading"
          :dataSource="courseChildTable.tableDataSource"
          :pagination="courseChildTable.tablePagination"
        >
          <div slot="versionName" slot-scope="text">
            {{ text.versionName ? text.versionName : '--' }}
          </div>
          <div slot="contentName" slot-scope="text">
            <div class="table_div">
              {{ text.contentName }}
            </div>
          </div>
          <div slot="abilityTypeName" slot-scope="text">
            <div class="self_td" v-for="item in text.abilitys" :key="item.id">
              {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
              {{ item.secondAbilityName }}
            </div>
          </div>
          <div slot="estimatedTime" slot-scope="text, record">
            {{ record.estimatedTime == 0 ? '--' : EstimatedTime(record.estimatedTime) }}
          </div>
          <div slot="device" slot-scope="text, record">
            <span v-for="item in hardwareList" :key="item.id">
              <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
            </span>
          </div>
          <div slot="ages" slot-scope="text, record">{{ record.minAge }} - {{ record.maxAge }}</div>
        </a-table>
      </div>
    </a-modal>
    <!-- 执行次数 -->
    <a-modal v-model="executionsNumberVisible" title="执行次数" @ok="executionsNumberOk">
      <a-form-model layout="inline" :model="snapshotForm">
        <a-form-model-item label="执行次数" prop="executionsNumber">
          <a-input-number style="width: 150px" allowClear :min="1" :max="9999" v-model="executionsNumber" placeholder="请输入执行次数" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 重新算分 -->
    <a-modal v-model="isResetComputed" title="重新算分" width="60%" :footer="null" destroyOnClose>
      <a-tabs @change="againTabChange">
        <a-tab-pane key="1" tab="算分任务">
          <a-table
            :columns="againCalculatePoints.firstColumns"
            :pagination="false"
            rowKey="projectCourseChildId"
            :scroll="{ y: 450 }"
            :loading="againCalculatePoints.tableRelevant.tableLoading"
            :dataSource="againCalculatePoints.tableRelevant.tableDataSource"
          >
            <a-table
              slot="expandedRowRender"
              slot-scope="firstText"
              :columns="againCalculatePoints.secondColumns"
              :rowKey="(record) => record.projectCourseChildId + ' ' + record.contentId"
              :row-selection="againCalculatePointsSelection"
              :data-source="firstText.childrens"
              :pagination="false"
            >
              <div slot="abilityTypeName" slot-scope="text">
                <div class="self_td" v-for="item in text.abilityDetails" :key="item.id">
                  {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                  {{ item.secondAbilityName }}
                </div>
              </div>
              <div slot="scoreSwitch" slot-scope="text, record">
                <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">
                  <a-switch checked-children="开" @change="againCPSwitch(text)" un-checked-children="关" v-model="item.scoreSwitch" />
                </div>
              </div>
            </a-table>
          </a-table>
          <div class="modal-footer">
            <a-button @click="isResetComputed = false"> 取消 </a-button>
            <a-button :loading="againReportLoading" @click="calculatePoints" type="primary"> 确定 </a-button>
          </div>
        </a-tab-pane>
        <a-tab-pane :disabled="!againCalculatePoints.initData" key="2" tab="常模配置">
          <a-table
            :columns="againCalculatePoints.normColumns"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 450 }"
            :loading="againCalculatePoints.normTable.tableLoading"
            :dataSource="againCalculatePoints.normTable.tableDataSource"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbilityNorms" :key="item.id">{{ item.abilityTypeName }} - {{ item.firstAbilityName }} - {{ item.secondAbilityName }}</div>
            </div>
            <div slot="setting" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbilityNorms" :key="item.id" style="flex-direction: column; align-items: flex-start">
                <a-select
                  v-model="item.select"
                  mode="multiple"
                  :maxTagCount="1"
                  :maxTagTextLength="150"
                  :style="`width: 240px;border-color: ${item.error ? 'red' : ''};`"
                  @change="(val) => normSettingChange(val, item)"
                  :getPopupContainer="normPopupContainer"
                  allowClear
                >
                  <a-select-option v-for="norm in item.normList" :disabled="norm.disabled" :value="norm.id" :key="norm.id">
                    {{ norm.name }}
                  </a-select-option>
                </a-select>
                <div v-if="item.error" style="color: red">{{ item.error }}</div>
              </div>
            </div>
          </a-table>
          <div class="modal-footer">
            <a-button @click="isResetComputed = false"> 取消 </a-button>
            <a-button :loading="againReportLoading" @click="courseNormOk" type="primary"> 确定 </a-button>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <!-- 清空快照 -->
    <a-modal v-model="isClearSnapshot" title="清空快照" @ok="clearSnapshot">
      <a-form-model layout="inline" :model="snapshotForm">
        <a-form-model-item label="是否强制更新所有内容" prop="delivery">
          <a-switch v-model="snapshotForm.forceFefresh" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant, FormatDate } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import { EstimatedTime } from '@/utils/EstimatedTime'
import XLSX from 'xlsx'

const columns = [
  {
    title: '课时名称',
    key: '1',
    dataIndex: 'childCourseName',
  },
  {
    title: '课时进度',
    key: '2',
    scopedSlots: { customRender: 'progress' },
  },
  {
    title: '完成率',
    key: '3',
    scopedSlots: { customRender: 'completionRate' },
  },
  {
    title: '最近使用时间',
    key: '4',
    dataIndex: 'lastUpdateProgressTime',
  },
  {
    title: '开课规则',
    key: '5',
    scopedSlots: { customRender: 'ruleType' },
  },
  {
    title: '是否启用',
    key: '6',
    scopedSlots: { customRender: 'enabled' },
  },
  {
    title: '操作',
    key: '9',
    scopedSlots: { customRender: 'action' },
  },
]
const rcColumns = [
  {
    title: '内容名称',
    dataIndex: 'contentName',
    align: 'center',
  },
  {
    title: '内容类型',
    align: 'center',
    dataIndex: 'contentType',
    scopedSlots: { customRender: 'contentType' },
  },
]
const courseChildColumns = [
  { title: '游戏名', dataIndex: 'name', width: 200 },
  { title: '版本名称', scopedSlots: { customRender: 'versionName' }, width: 100 },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    align: 'center',
    width: 250,
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '用时', scopedSlots: { customRender: 'estimatedTime' }, align: 'center', key: 'time' },
  { title: '设备要求', scopedSlots: { customRender: 'device' }, align: 'center', key: 'device' },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center', key: 'createTime' },
]
const snapshotColumns = [
  {
    title: '排列顺序',
    dataIndex: 'displayOrder',
  },
  {
    title: '内容名称',
    ellipsis: true,
    dataIndex: 'contentName',
  },
  {
    title: '版本名称',
    ellipsis: true,
    dataIndex: 'contentVersionName',
  },
  {
    title: '内容类型',
    dataIndex: 'contentType',
    scopedSlots: { customRender: 'contentType' },
  },
  {
    title: '能力维度',
    class: 'testClass',
    width: 250,
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '学科名称',
    class: 'testClass',
    scopedSlots: { customRender: 'scientificName' },
  },
  {
    title: '执行次数',
    dataIndex: 'executionsNumber',
  },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
  },
  {
    title: '操作',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'StudentsManage',
  data() {
    return {
      EstimatedTime,
      spinning: false,
      columns,
      //表格相关
      tableRelevant: tableRelevant.call(this),
      searchForm: {
        childCourseName: undefined,
        statuses: undefined,
      },
      ruleType: ['默认开课', '依次开课', '延迟天数开课', '定时开课', '付费开课'],
      rcColumns,
      rcLoading: false,
      rcSelectList: [], //重新算分选中
      isResetComputed: false, //重新算分弹窗
      rcTable: tableRelevant.call(this, this.getRcData), //重新算分弹窗数据

      snapshotColumns: snapshotColumns,
      snapshotTable: tableRelevant.call(this, this.snapshotList),
      //课时快照相关
      snapshotRelevant: {
        visible: false,
        snapshotNowId: '',
        customerCourseId: '',
      },
      //重置内容
      snapshotResetRelevant: {
        visible: false,
        //当前课时数据
        nowInfo: {},
        contentId: '',
      },
      selectedRows: [], //选中数组
      tableSelectedRowKeys: [], //选中数组
      allSnapshotResetId: '', //
      //课时快照
      selectId: [],
      options: [],
      courseChildForm: {
        Enabled: true,
        Name: '',
        versionName: undefined,
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
        minAge: undefined,
        maxAge: undefined,
      },
      //设备
      hardwareList: [
        { id: 4, name: '耳机', icon: require('@/assets/img/ej.png') },
        { id: 8, name: '麦克风', icon: require('@/assets/img/mkf.png') },
        { id: 32, name: '陀螺仪', icon: require('@/assets/img/tly.png') },
      ],
      courseChildColumns,
      courseChildTable: tableRelevant.call(this, this.getCourseChildTableData),
      selectedRowKeys: [],
      //能力类型
      ability: [],
      //一级能力
      firstAbility: [],
      //二级能力
      secondAbility: [],
      allSnapshotResetId2: '', //
      resetType: -1, //类型
      hadleTit: '', //当前操作(删除、添加、替换)
      confirmLoading: false,
      againReportLoading: false,
      exportCourseDataLoading: false,
      isClearSnapshot: false,
      snapshotForm: {
        forceFefresh: false,
      },

      tableExpandedRowKeys: [], //表格展开的行
      // 重新算分
      againCalculatePoints: {
        visible: false,
        firstColumns: [{ title: '课时名称', dataIndex: 'childCourseName' }],
        secondColumns: [
          { title: '任务名称', dataIndex: 'contentName' },
          { title: '能力类型', class: 'testClass', scopedSlots: { customRender: 'abilityTypeName' } },
          { title: '算分开关', class: 'testClass', scopedSlots: { customRender: 'scoreSwitch' } },
        ],
        tableRelevant: tableRelevant.call(this),
        selectedRowKeys: [],

        normColumns: [
          { title: '任务名称', dataIndex: 'name' },
          { title: '能力类型', class: 'testClass', scopedSlots: { customRender: 'abilityTypeName' } },
          { title: '常模配置', class: 'testClass', scopedSlots: { customRender: 'setting' } },
        ],
        normTable: tableRelevant.call(this),
        initData: false,
      },
      projectCourseChildId: '',
      Record: '',
      queryArr: [],
      thisData: [],

      // 执行次数
      executionsNumberVisible: false,
      executionsNumber: undefined,

      contentIds: [],
      simpleReportLoading: false,
    }
  },
  mounted() {
    setTimeout(() => this.getPageList(), 200)
    const arr = [
      '首页',
      '项目实施',
      {
        name: '课程管理',
        path: decodeURIComponent(this.$route.query.fullPath),
      },
      '课程详情',
    ]
    this.getAbility()
    $Bus.$emit('pageHeaderBreadcrumb', arr)
    this.abilityTypeSelect(0)
  },
  computed: {
    tableSelection() {
      return {
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.tableSelectedRowKeys = selectedRowKeys
          this.selectedRows = this.selectedRows.reduce((pre, cur) => {
            if (this.tableSelectedRowKeys.includes(cur.id) && !pre.filter((f) => f.id === cur.id).length) {
              pre.push(cur)
            }
            return pre
          }, selectedRows)
        },
      }
    },
    rowSelection() {
      return {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRows
        },
        getCheckboxProps: (record) => ({
          props: {
            name: record.name,
            disabled: this.contentIds.includes(record.id),
          },
        }),
      }
    },
    // 重新算分
    againCalculatePointsSelection() {
      return {
        selectedRowKeys: this.againCalculatePoints.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.againCalculatePoints.selectedRowKeys = selectedRowKeys
          console.log(this.againCalculatePoints.selectedRowKeys)
        },
      }
    },
  },
  methods: {
    // 能力维度
    onChange(value) {
      this.courseChildForm.AbilityTypeId = value[0]
      this.courseChildForm.FirstAbilityId = value[1]
      this.courseChildForm.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
            targetOption.loading = false
            targetOption.children = res.data.data.map((m) => ({
              ...m,
              value: m.id,
              label: m.name,
              isLeaf: m.levelNumber > 1,
            }))
            this.options = [...this.options]
            resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
          this.options = res.data.data
          this.options.forEach((item) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
          if (this.courseChildForm.AbilityTypeId) {
            this.loadData(this.options.filter((f) => f.id === this.courseChildForm.AbilityTypeId)).then((data) => {
              if (this.courseChildForm.FirstAbilityId) {
                this.loadData(data.filter((f) => f.id === this.courseChildForm.FirstAbilityId))
              }
            })
        }
      })
    },
    // 清空快照
    openSnapshot() {
      if (!this.selectedRows.length) {
        this.$message.destroy()
        this.$message.warning('请选择课时')
        return
      }
      this.isClearSnapshot = true
    },
    // 清空快照
    clearSnapshot() {
      let ids = []
      this.selectedRows.forEach((v) => {
        ids.push(v.id)
      })
      let formData = new FormData()
      ids.forEach((el, index) => {
        formData.append(`projectCourseChilds[${index}]`, el)
      })
      formData.append('forceFefresh', this.snapshotForm.forceFefresh)
      this.$http
        .UpdatrCourseChildContents(formData)
        .then((res) => {
          this.$message.destroy()
          this.$message.success('操作成功')
          this.tableSelectedRowKeys = []
          this.selectedRows = []
          this.isClearSnapshot = false
          this.getPageList()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //获取课程详情列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        courseId: this.$store.getters['organization/getCourseInfo']().courseId,
        customerCourseId: this.$store.getters['organization/getCourseInfo']().id,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.Course.newcourseDetailsList(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data.items.map((m) => {
            if (['1900-01-01 00:00:00', '0001-01-01 00:00:00'].includes(m.lastUpdateProgressTime)) {
              m.lastUpdateProgressTime = '--'
            }
            return m
          })
          this.tableRelevant.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //重置
    searchReset() {
      this.searchForm.childCourseName = undefined
      this.searchForm.statuses = undefined
      this.getPageList(1)
    },

    batchSettlement() {
      let _this = this
      if (!this.selectedRows.length) {
        this.$message.destroy()
        this.$message.warning('请选择')
        return
      }
      this.$confirm({
        title: '提示',
        content: `一共选中 ${this.selectedRows.length} 个课时，确定结算？`,
        onOk() {
          _this.settlement()
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    settlement() {
      let arr = []
      this.selectedRows.forEach((el) => {
        arr.push(el.id)
      })
      const formData = new FormData()
      arr.forEach((el, index) => {
        formData.append(`customerChildCourseIds`, el)
      })
      this.tableRelevant.tableLoading = true
      this.$http.Course.courseHourSettlement(formData)
        .then((res) => {
          this.$message.success('操作成功！')
          this.tableSelectedRowKeys = []
          this.selectedRows = []
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //重置内容点击内容替换关闭弹框刷新列表
    closeModal() {
      this.snapshotResetRelevant.visible = false
      this.snapshotList()
    },

    //获取课时快照列表
    snapshotList(val, pageIndex) {
      this.snapshotRelevant.visible = true
      this.snapshotTable.tableLoading = true
      if (val) {
        this.snapshotRelevant.snapshotNowId = val.id
        this.snapshotRelevant.customerCourseId = this.$store.getters['organization/getCourseInfo']().id
        this.snapshotResetRelevant.nowInfo = val
        this.allSnapshotResetId = val.courseChildId
        sessionStorage.setItem('allSnapshotResetId', val.courseChildId)
      }
      if (pageIndex) {
        this.snapshotTable.tablePagination.current = pageIndex
      }
      const params = {
        // ProjectCourseChildId: val ? val.id : this.snapshotRelevant.snapshotNowId,
        customerChildCourseId: val ? val.id : this.snapshotRelevant.snapshotNowId,
        customerCourseId: val ? this.$store.getters['organization/getCourseInfo']().id : this.snapshotRelevant.customerCourseId,
        pageIndex: pageIndex || this.snapshotTable.tablePagination.current,
        pageSize: this.snapshotTable.tablePagination.pageSize,
      }

      this.$http.Course.snapshotPagelist(params)
        .then((res) => {
          const { data } = res
          this.snapshotTable.tableDataSource = data.items
          this.snapshotTable.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.snapshotTable.tableLoading = false
        })
    },
    //全部重置
    allSnapshotReset() {
      this.$message.destroy()
      if (!this.snapshotTable.tableDataSource.length) {
        this.$message.warn('无重置的内容')
        return
      }
      const that = this
      this.$confirm({
        title: '确认要重置全部内容吗?',
        centered: true,
        onOk() {
          const params = {
            ProjectCourseConfigId: that.$store.getters['organization/getCourseInfo']().id,
            ProjectCourseChildId: that.snapshotRelevant.snapshotNowId,
            ChildCourseId: that.allSnapshotResetId,
          }
          that.spinning = true
          that.$http.Course.replaceChangecontent(params)
            .then((res) => {
              const { message } = res
              that.$message.success(message)
              that.snapshotList()
            })
            .finally(() => {
              that.spinning = false
            })
        },
      })
    },
    //替换内容
    snapshotReset(val) {
      this.snapshotResetRelevant.visible = true
      this.snapshotResetRelevant.contentId = val.contentId
      this.allSnapshotResetId2 = sessionStorage.getItem('allSnapshotResetId')
      this.resetType = 1
      this.hadleTit = '替换'
      this.getCourseChildTableData()
      this.getCourseChildSnapshotContentIds()
    },
    modleOk() {
      this.snapshotRelevant.visible = false
    },

    // 重新算分弹窗
    resetComputed() {
      this.isResetComputed = true
      this.getRcData(1)
    },

    // 展开行
    expandedRowsChange(expandedRowKeys) {
      this.tableExpandedRowKeys = expandedRowKeys
    },
    // 获取课时内容
    getContents(expanded, record) {
      if (expanded) {
        this.projectCourseChildId = record.id
        this.Record = record
        let str = {
          projectCourseChildId: record.id,
          contentAbilityValidDic: [],
        }

        let params = {
          ProjectCourseChildId: record.id,
          projectCourseConfigId: this.$store.getters['organization/getCourseInfo']().id,
        }
        record.childTableLoading = true
        this.$http.Course.GetProjectCoursechildDetail(params)
          .then((res) => {
            record.childTableData = res.data
            record.childTableLoading = false
            this.thisData = res.data
            this.thisData.forEach((v) => {
              v.abilityDetails.forEach((m) => {
                str.contentAbilityValidDic.push(m)
              })
            })
            this.queryArr.push(str)
            let obj = {}
            this.queryArr = this.queryArr.reduce((newArr, next) => {
              obj[next.projectCourseChildId] ? '' : (obj[next.projectCourseChildId] = true && newArr.push(next))
              return newArr
            }, [])
          })
          .catch((err) => {
            console.log(err)
            record.childTableLoading = false
          })
      }
    },
    // 获取弹窗数据
    getRcData() {
      let params = {
        projectCourseConfigId: this.$store.getters['organization/getCourseInfo']().id,
      }
      this.isResetComputed = true
      this.againCalculatePoints.selectedRowKeys = []
      this.againCalculatePoints.tableRelevant.tableLoading = true
      this.$http.Course.GetConfigsByProjectCourseConfigId(params)
        .then((res) => {
          const { data } = res
          const dataObj = data.reduce((prev, curr) => {
            if (curr.abilityDetails.some((s) => s.scoreSwitch)) {
              this.againCalculatePoints.selectedRowKeys.push(curr.projectCourseChildId + ' ' + curr.contentId)
            }
            if (prev[curr.childCourseName]) {
              prev[curr.childCourseName].push(curr)
            } else {
              prev[curr.childCourseName] = [curr]
            }
            return prev
          }, {})
          const tableData = []
          for (const key in dataObj) {
            tableData.push({
              childCourseName: key,
              childrens: dataObj[key],
              projectCourseChildId: dataObj[key][0].projectCourseChildId,
            })
          }
          this.againCalculatePoints.tableRelevant.tableDataSource = tableData
          this.againCalculatePoints.initData = true
        })
        .finally(() => {
          this.againCalculatePoints.tableRelevant.tableLoading = false
        })
    },
    //重新算分
    calculatePoints() {
      this.$message.destroy()
      if (!this.againCalculatePoints.selectedRowKeys.length) {
        this.$message.error('请选择需要重新算分的游戏')
        return
      }
      const requestBody = this.againCalculatePoints.tableRelevant.tableDataSource.reduce((prev, curr) => {
        for (let i = 0; i < curr.childrens.length; i++) {
          if (this.againCalculatePoints.selectedRowKeys.includes(curr.childrens[i].projectCourseChildId + ' ' + curr.childrens[i].contentId)) {
            prev.push({
              projectCourseChildId: curr.childrens[i].projectCourseChildId,
              customerCourseId: this.$store.getters['organization/getCourseInfo']().id,
              contentId: curr.childrens[i].contentId,
              contentAbilityIds: curr.childrens[i].abilityDetails.filter((f) => f.scoreSwitch).map((m1) => m1.abilityId),
            })
          }
        }
        return prev
      }, [])
      this.againReportLoading = true
      this.$http
        .UpdateCourseContentScore(requestBody)
        .then((res) => {
          this.rcSelectList = []
          this.isResetComputed = false
          this.$message.success(res.message)
        })
        .finally(() => {
          this.againReportLoading = false
        })
    },
    againCPSwitch(val) {
      if (!this.againCalculatePoints.selectedRowKeys.includes(val.projectCourseChildId + ' ' + val.contentId)) {
        this.againCalculatePoints.selectedRowKeys.push(val.projectCourseChildId + ' ' + val.contentId)
      }
    },

    againTabChange(value) {
      if (value == 2) {
        this.getCourseContentNorms()
      }
    },
    getCourseContentNorms() {
      console.log(this.againCalculatePoints.tableRelevant.tableDataSource)

      const contentIds = []
      this.againCalculatePoints.tableRelevant.tableDataSource.forEach(({ childrens }) => {
        if (childrens) {
          contentIds.push(...childrens.map((v) => v.contentId))
        }
      })
      const Params = {
        conetnetIds: contentIds,
      }
      this.againCalculatePoints.normTable.tableLoading = true
      this.$http.Content.getCourseContentNorms(Params)
        .then(async (res) => {
          await this.$http.CourseService.getCourseNorm(this.$store.getters['organization/getCourseInfo']().id).then((res1) => {
            this.againCalculatePoints.normTable.tableDataSource = res.data.map((m) => {
              m.contentAbilityNorms = m.contentAbilityNorms.map((norm) => {
                const item = res1.data.find((f) => f.contentAbilityId === norm.contentAbilityId) || {}
                if (item.normIds) {
                  norm.select = item.normIds.filter((f) => norm.normList.some((s) => s.id === f))
                } else {
                  norm.select = norm.normList.filter((f) => f.isDefault).map((m) => m.id)
                }
                if (!norm.select.length) {
                  norm.error = '未配置常模'
                } else {
                  this.normSettingChange(norm.select, norm)
                }
                return norm
              })
              return m
            })
            return res
          })
        })
        .finally(() => {
          this.againCalculatePoints.normTable.tableLoading = false
        })
    },
    normSettingChange(value = [], ability) {
      ability.error = !value.length && '请选择常模'
      ability.normList = ability.normList.map((m) => {
        m.disabled = false
        value.forEach((f) => {
          const item = ability.normList.find((fi) => fi.id === f)
          if (item && m.id !== f && item.regionId === m.regionId && item.deviceType === m.deviceType) {
            m.disabled = true
          }
        })
        return m
      })
    },
    normPopupContainer(node) {
      if (this.againCalculatePoints.normTable.tableDataSource.length < 5) {
        return document.body
      }
      return node.parentElement
    },
    courseNormOk() {
      const Params = {
        organizationCourseId: this.$store.getters['organization/getCourseInfo']().id,
        contentNormConfigList: this.againCalculatePoints.normTable.tableDataSource.map((m) => {
          return {
            contentId: m.id,
            contentVersion: m.contentVersion,
            normConfigList: m.contentAbilityNorms.map((norm) => {
              return {
                contentAbilityId: norm.contentAbilityId,
                normIds: norm.select || [],
              }
            }),
          }
        }),
      }
      this.againReportLoading = true
      this.$http.CourseService.submitCourseNorm(Params)
        .then((res) => {
          this.rcSelectList = []
          this.isResetComputed = false
          this.$message.success(res.message)
        })
        .finally(() => {
          this.againReportLoading = false
        })
    },

    //重置内容获取课程列表
    getCourseChildTableData(pageIndex) {
      let contentTypes = undefined
      if (this.snapshotResetRelevant.nowInfo.childCourseType === 1) {
        contentTypes = this.$data._contentType.map((m, i) => {
          if (!i || i === 2) {
            return undefined
          }
          return i
        })
      }
      if (this.snapshotResetRelevant.nowInfo.childCourseType === 3) {
        contentTypes = [4, 6]
      }
      const params = {
        pageIndex: pageIndex || this.courseChildTable.tablePagination.current,
        pageSize: this.courseChildTable.tablePagination.pageSize,
        contentType: contentTypes,
        ...this.courseChildForm,
      }
      this.courseChildTable.tableLoading = true

      this.$http
        .contentlist(params)
        .then((res) => {
          const data = res.data
          this.courseChildTable.tableDataSource = data.items
          this.courseChildTable.tablePagination.total = data.totalCount
          this.courseChildTable.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.courseChildTable.tableLoading = false
          this.snapshotTable.tableLoading = false
        })
    },
    getCourseChildSnapshotContentIds() {
      let params = {
        customerCourseId: this.$store.getters['organization/getCourseInfo']().id,
        customerChildCourseId: this.snapshotResetRelevant.nowInfo.id,
        userChildCourseId: '',
      }
      this.$http.Course.getCourseChildSnapshotContentIds(params).then((res) => {
        const { data } = res
        console.log(data)
        this.contentIds = data
      })
    },
    //重置搜索
    courseChildsearchReset(str) {
      for (let key in this.courseChildForm) {
        this.courseChildForm[key] = undefined
      }
      this.courseChildForm.Enabled = true
      this.selectId = []
      this.firstAbility = []
      this.secondAbility = []
      if (str !== 'cancel') {
        this.getCourseChildTableData(1)
      }
    },
    //获取能力
    getAbility(id, type) {
      let params = {
        level: 0,
      }
      if (id) {
        params = {
          pid: id,
        }
      }
      this.$http.CommonInterface.getAbility(params).then((res) => {
        const { data } = res
        switch (type) {
          case 1:
            this.firstAbility = data
            this.courseChildForm.secondAbilityId = undefined
            this.courseChildForm.firstAbilityId = undefined
            this.secondAbility = []
            break
          case 2:
            this.secondAbility = data
            this.courseChildForm.secondAbilityId = undefined
            break
          default:
            this.ability = data
        }
      })
    },
    // 重置内容确定按钮
    replace() {
      this.$message.destroy()
      if (!this.selectedRowKeys.length && this.resetType != 2) {
        this.$message.warn('请选择内容')
        return
      }
      this.executionsNumberVisible = true
    },
    executionsNumberOk(deleteId) {
      this.$message.destroy()
      if (!this.executionsNumber && this.resetType != 2) {
        this.$message.warn('请输入执行次数')
        return
      }
      const that = this
      that.confirmLoading = true
      this.$confirm({
        title: '确认要' + that.hadleTit + '当前内容吗?',
        centered: true,
        okButtonProps: {
          props: { loading: false },
        },
        onOk() {
          that.confirmLoading = true
          let params = {}
          // 添加
          if (that.resetType == 0) {
            that.courseChildTable.tableLoading = true
            params = {
              customerCourseId: that.$store.getters['organization/getCourseInfo']().id,
              customerChildCourseId: that.snapshotResetRelevant.nowInfo.id,
              contentId: that.selectedRowKeys[0].id,
              executionsNumber: that.executionsNumber,
              resetType: that.resetType,
            }
            // 替换
          } else if (that.resetType == 1) {
            that.courseChildTable.tableLoading = true
            params = {
              customerCourseId: that.$store.getters['organization/getCourseInfo']().id,
              customerChildCourseId: that.snapshotResetRelevant.nowInfo.id,
              originalContentId: that.snapshotResetRelevant.contentId, //添加不传
              contentId: that.selectedRowKeys[0].id,
              executionsNumber: that.executionsNumber,
              resetType: that.resetType,
            }
            //删除
          } else {
            that.snapshotTable.tableLoading = true
            params = {
              customerCourseId: that.$store.getters['organization/getCourseInfo']().id,
              customerChildCourseId: that.snapshotResetRelevant.nowInfo.id,
              originalContentId: deleteId, //添加不传
              resetType: that.resetType,
            }
          }
          that.$http
            .ChildCourseContentSnapshotReset(params)
            .then((res) => {
              that.confirmLoading = false
              that.executionsNumberVisible = false
              that.snapshotResetRelevant.visible = false
              that.$message.success(res.message)
              that.$emit('closeModal')
              that.snapshotList()
              that.selectedRowKeys = []
            })
            .finally(() => {
              that.confirmLoading = false
            })
        },
        onCancel() {
          that.confirmLoading = false
        },
      })
    },

    // 添加内容
    addContent() {
      this.snapshotResetRelevant.visible = true
      // this.snapshotResetRelevant.contentId = val.contentId;
      this.allSnapshotResetId2 = sessionStorage.getItem('allSnapshotResetId')
      this.resetType = 0
      this.hadleTit = '添加'
      this.getCourseChildTableData()
      this.getCourseChildSnapshotContentIds()
    },
    // 删除内容
    deleteContent(record) {
      this.resetType = 2
      this.hadleTit = '删除'
      this.executionsNumberOk(record.contentId)
    },
    // 导出数据
    exportData() {
      this.$message.destroy()
      if (!this.selectedRows.length) {
        this.$message.warn('请选择课时')
        return
      }
      const Params = {
        projectCourseConfigId: this.$store.getters['organization/getCourseInfo']().id,
        childCourseIds: this.selectedRows.map((m) => m.courseChildId),
      }
      this.exportCourseDataLoading = true
      this.$http.CourseCenter.getUserCourseAbilityScoreData(Params)
        .then((res) => {
          const { data } = res
          if (!data.length) {
            this.$message.error('暂无数据')
            return
          }
          const xlsxName = this.$store.getters['organization/getCourseInfo']().name + '数据' + FormatDate(Date.now(), 'YYYYMMDDhhmmss')
          const workbook = XLSX.utils.book_new()
          let courseData = [['学生姓名', '课程得分']]
          if (data[0].items.length) {
            courseData = [
              ['学生姓名', '课程得分', ...Object.keys(data[0].items[0].abilityScoreDict).map((m) => m + '得分'), ...Object.keys(data[0].items[0].contentScoreDict)],
              ...data[0].items.map((m) => {
                return [m.userName, m.score, ...Object.values(m.abilityScoreDict), ...Object.values(m.contentScoreDict)]
              }),
            ]
          }
          XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(courseData), '课程')
          if (data.length > 1) {
            for (let i = 1; i < data.length; i++) {
              let courseHourData = [['学生姓名', '课时得分']]
              if (data[i].items.length) {
                courseHourData = [
                  ['学生姓名', '课时得分', ...Object.keys(data[i].items[0].abilityScoreDict).map((m) => m + '得分'), ...Object.keys(data[i].items[0].contentScoreDict)],
                  ...data[i].items.map((m) => {
                    return [m.userName, m.score, ...Object.values(m.abilityScoreDict), ...Object.values(m.contentScoreDict)]
                  }),
                ]
              }
              XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(courseHourData), data[i].name)
            }
          }
          // 保存为Excel文件
          XLSX.writeFile(workbook, xlsxName + '.xlsx')
        })
        .finally(() => {
          this.exportCourseDataLoading = false
        })
    },
  },
}
</script>

<style scoped lang="less">
.search {
  margin-bottom: 15px;
}

.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.operator {
  margin-top: 15px;
}

/deep/ .alert {
  display: none;
}

/deep/ .ant-table-thead .testClass {
  padding: 0 16px !important;
}

/deep/ .ant-table-row .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  //flex-direction: column;
  //justify-content: center;
  padding: 6px 16px;
}

.statusName {
  display: flex;
  align-items: center;
  // justify-content: center;
  .yuan {
    width: 6px;
    height: 6px;
    border-radius: 6px;
    display: inline-block;
    background-color: #bfbfbf;
    margin-right: 5px;
  }

  .active0 {
    background-color: #ffc004;
  }

  .active1 {
    background-color: #1179d1;
  }

  .active2 {
    background-color: #04a956;
  }

  .active3 {
    background-color: #bbb;
  }
}

.modal-footer {
  margin-top: 24px;
  text-align: right;

  .ant-btn {
    margin-left: 24px;
  }
}
</style>
